
export default function ChangePassword() {
   return (
      <main className="flex flex-jc-c flex-ai-c">
         <div className="backGround"></div>

      </main>
   )
}